import api from './AxiosService';

const CategoryService = {
  // Event Categories (Category collection)
  getAllEventCategories: () => api.get('/category/all'),
  addEventCategory: (data) => api.post('/category/add', data),
  updateEventCategory: (id, data) => api.put(`/category/${id}`, data),
  deleteEventCategory: (id) => api.delete(`/category/${id}`),
  toggleEventCategoryStatus: (id, isHidden) => api.put(`/category/status/${id}`, { isHidden }),

  // Contest Categories (EventType collection)
  getAllContestCategories: () => api.get('/contests/types'),
  addContestCategory: (data) => api.post('/contests/types/add', data),
  updateContestCategory: (id, data) => api.put(`/contests/types/${id}`, data),
  deleteContestCategory: (id) => api.delete(`/contests/types/${id}`),

  // Fallback aliases
  getAll: () => api.get('/category/all'),
  add: (data) => api.post('/category/add', data),
  update: (id, data) => api.put(`/category/${id}`, data),
  delete: (id) => api.delete(`/category/${id}`),
  toggleStatus: (id, isHidden) => api.put(`/category/status/${id}`, { isHidden }),
};

export default CategoryService;
